export const baseURL = "https://admin.talentinco.com/";
export const key = "LiRhuZZejJFrDZEHCtyLO0q2bDuIIhJL";

    